import React from 'react'
import I18n from 'i18n'
import StackedLineChart from './StackedLineChart'
import { stackedChartColors } from '../../../common/Constants'
import { sortedDays, transparentize } from '../../../common/Utils'
import { filterAndRotateActivityData } from './ActivityUtils'

const WeeklySleepChart = (props) => {
  const filteredData = filterAndRotateActivityData(props.params, props.barParams, props.datasets)
  const datasets = []
  filteredData.filter(serie => props.barParams.includes(serie.param)).forEach(serie => {
    const idx = props.barParams.findIndex(elem => elem === serie.param)
    datasets.push({
      label: I18n.t(`analysis.dashboard.${serie.param}.title`),
      fill: '-1',
      backgroundColor: transparentize(stackedChartColors[idx]),
      borderColor: stackedChartColors[idx],
      data: serie.mean
    })
  })

  return (
    <StackedLineChart
      labels={sortedDays()}
      datasets={datasets}
      yLabel={props.yLabel}
      title={props.title}
    />
  )
}

export default WeeklySleepChart
